import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Business, DirectionsBoat } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkRequiredPermissions, USER_GROUPS } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import CollapseGroup from "../CollapseGroup";
/**
 * ContactsModule
 * DeviceModule
 * MaintenanceModule
 * SoftwareModule
 * SystemModule
 */
export default function SoftwareModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Allowed Uswer groups
  return checkRequiredPermissions([USER_GROUPS.ADMIN]) ? (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/shipments");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<DirectionsBoat />}
      header={t("shipments.header")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/shipments/companies");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <Business />
        </ListItemIcon>
        <ListItemText primary={t("shipments.shippingCompanies")} />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
